/**
 * Motion driver bus — bridges the rAF playback loop to the imperative pose
 * applier without routing 60Hz updates through React.
 *
 * `useEventActorMotion` registers an `apply(t)` that samples every baked track
 * and writes scene transforms. `usePlaybackLoop` advances a live clock each
 * animation frame and calls `driveMotion(t)` directly, so the aircraft move at
 * the display refresh rate while the Zustand `currentTime` (which drives React
 * re-renders) is only written ~10×/sec for the timeline UI and membership sync.
 *
 * Single demo instance, so a module-level singleton is sufficient; the applier
 * is registered with `null` on unmount and `driveMotion` no-ops when unset.
 */
type ApplyFn = (t: number) => void

let apply: ApplyFn | null = null

export function registerMotionApply(fn: ApplyFn | null): void {
  apply = fn
}

export function driveMotion(t: number): void {
  apply?.(t)
}
